import { SignupModel } from "../../signup/models/signup.model";

export class BatchUploadPersonModel {
  sVGModel: Array<SVGModel>;
  assignToDriver: boolean;
  signupModel: Array<SignupModel>;
  organizationMasterHashId: string;
  
  constructor() {
    this.sVGModel = new Array<SVGModel>();
    this.signupModel = new Array<SignupModel>();
  }
}

export class SVGModel {
  subscriptionId: string;
  sharedvehiclegroupHashId: string;
  groupName: string;
  subscriptionName: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/batchuploadperson/model/batch-upload-person.model.ts